(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prana-founder-journey"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('prana-journey-reveal')) {
  customElements.define('prana-journey-reveal', class extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('pf-revealed');
          this.observer.unobserve(entry.target);
        });
      }, { threshold:0.1 });
      this.querySelectorAll('.pf-milestone').forEach((item) => this.observer.observe(item));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prana-ugc-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';

    const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

    function loadSwiperAssets() {
      if (!document.querySelector('link[data-prana-swiper-css]')) {
        const link = document.createElement('link');

        link.rel = 'stylesheet';

        link.href = SWIPER_CSS;

        link.setAttribute('data-prana-swiper-css', '');

        document.head.appendChild(link);
      }

      if (window.Swiper) return Promise.resolve();

      if (window.__pranaSwiperPromise) return window.__pranaSwiperPromise;

      window.__pranaSwiperPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector('script[data-prana-swiper-js]');

        if (existing) {
          existing.addEventListener('load', resolve, { once: true });

          existing.addEventListener('error', reject, { once: true });

          return;
        }

        const script = document.createElement('script');

        script.src = SWIPER_JS;

        script.defer = true;

        script.setAttribute('data-prana-swiper-js', '');

        script.onload = resolve;

        script.onerror = reject;

        document.head.appendChild(script);
      });

      return window.__pranaSwiperPromise;
    }

    if (!customElements.get('prana-ugc-videos')) {
      customElements.define(
        'prana-ugc-videos',

        class extends HTMLElement {
          connectedCallback() {
            this.controller = new AbortController();

            const signal = this.controller.signal;

            this.autoplayVideos = this.dataset.autoplay === 'true';

            this.sliderAutoplay = this.dataset.sliderAutoplay === 'true';

            this.sliderSpeed = Math.max(1000, Number(this.dataset.sliderSpeed || 3000));

            this.desktopVideos = Math.max(1, Number(this.dataset.desktopVideos || 4));

            this.mobileVideos = Math.max(1, Number(this.dataset.mobileVideos || 1));

            this.querySelectorAll('video').forEach((video) => {
              video.muted = true;

              video.loop = true;

              video.playsInline = true;
            });

            this.setupVideoAutoplay();

            this.initSwiper();

            this.addEventListener(
              'shopify:block:select',

              (event) => {
                const slide = event.target.closest('.swiper-slide');

                if (!slide || !this.swiper) return;

                const index = Array.from(this.querySelectorAll('.swiper-slide')).indexOf(slide);

                if (index >= 0) this.swiper.slideTo(index);
              },

              { signal }
            );
          }

          async initSwiper() {
            try {
              await loadSwiperAssets();

              if (!this.isConnected || this.swiper) return;

              const swiperEl = this.querySelector('.prana-ugc__swiper');

              const prevEl = this.querySelector('.prana-ugc__prev');

              const nextEl = this.querySelector('.prana-ugc__next');

              if (!swiperEl) return;

              const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

              this.swiper = new window.Swiper(swiperEl, {
                slidesPerView: this.mobileVideos,

                spaceBetween: 14,

                speed: 600,

                grabCursor: true,

                watchOverflow: true,

                loop: true,

                observer: true,

                observeParents: true,

                navigation: {
                  prevEl,

                  nextEl,
                },

                autoplay:
                  this.sliderAutoplay && slideCount > 1
                    ? {
                        delay: this.sliderSpeed,

                        disableOnInteraction: false,

                        pauseOnMouseEnter: true,
                      }
                    : false,

                breakpoints: {
                  750: {
                    slidesPerView: this.desktopVideos,

                    spaceBetween: 20,
                  },
                },
              });
            } catch (error) {
              console.error('PRANA UGC Swiper failed to load:', error);
            }
          }

          setupVideoAutoplay() {
            if (!this.autoplayVideos) return;

            if ('IntersectionObserver' in window) {
              this.visibilityObserver = new IntersectionObserver(
                (entries) => {
                  entries.forEach((entry) => {
                    const video = entry.target;

                    if (!entry.isIntersecting || entry.intersectionRatio < 0.25) {
                      video.pause();

                      return;
                    }

                    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                      video.muted = true;

                      video.play().catch(() => {});
                    }
                  });
                },

                { threshold: [0, 0.25] }
              );

              this.querySelectorAll('video').forEach((video) => {
                this.visibilityObserver.observe(video);
              });
            } else {
              this.querySelectorAll('video').forEach((video) => {
                video.play().catch(() => {});
              });
            }
          }

          disconnectedCallback() {
            this.controller?.abort();

            this.visibilityObserver?.disconnect();

            this.swiper?.destroy(true, true);

            this.querySelectorAll('video').forEach((video) => {
              video.pause();
            });
          }
        }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
